import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from 'axios';

const baseUrl = process.env.REACT_APP_BASE_URL;

//action

export const createPannaEntry = createAsyncThunk('createPannaEntry', async (postData) => {

    try {
        const response = await axios.post(`${baseUrl}?apicall=insertPanna`, postData);
        return response.data;
    } catch (error) {
        throw error;
    }
});

export const updatePannaEntry = createAsyncThunk('updatePannaEntry', async (postData) => {
    try {
        const response = await axios.post(`${baseUrl}?apicall=updatePanna`, postData);
        return response.data;
    } catch (error) {
        throw error;
    }
});

export const fetchPannaData = createAsyncThunk('fetchPannaData', async () => {
    try {
        const response = await axios.get(`${baseUrl}?apicall=getpannalist`);
        return response.data;
    } catch (error) {
        throw error;
    }
});

export const fetchSinglePanna = createAsyncThunk('fetchSinglePanna', async (id) => {
    try {
        const response = await axios.get(`${baseUrl}?apicall=getpannalist&panaId=${id}`);
        return response.data;
    } catch (error) {
        throw error;
    }
});


export const deleteSinglePanna = createAsyncThunk('deleteSinglePanna', async (id) => {
    try {
        const response = await axios.delete(`${baseUrl}?apicall=deletePanna&panaId=${id}`);
        return response.data;
    } catch (error) {
        throw error;
    }
});


const pannaSlice = createSlice({
    name: 'PannaData',
    initialState: {
        isLoading: false,
        pana: null,
        deletePana: null,
        singlePana: null,
        isError: false
    },
    extraReducers: (builder) => {
        builder.addCase(fetchPannaData.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(fetchPannaData.fulfilled, (state, action) => {
            state.isLoading = false;
            state.pana = action.payload;
        });
        builder.addCase(fetchPannaData.rejected, (state, action) => {
            console.log('Error', action.error.message);
            state.isError = true;
        });

        builder.addCase(deleteSinglePanna.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(deleteSinglePanna.fulfilled, (state, action) => {
            state.isLoading = false;
            state.deletePana = action.payload;
        });
        builder.addCase(deleteSinglePanna.rejected, (state, action) => {
            console.log('Error', action.error.message);
            state.isError = true;
        });


        builder.addCase(fetchSinglePanna.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(fetchSinglePanna.fulfilled, (state, action) => {
            state.isLoading = false;
            state.singlePana = action.payload;
        });
        builder.addCase(fetchSinglePanna.rejected, (state, action) => {
            console.log('Error', action.error.message);
            state.isError = true;
        });




    }
});

export default pannaSlice.reducer;
